/**
 * package: com.inq.utils
 * class: Point
 * root Object
 * @constructor
 */
com.inq.utils.Point = function(x,y) {
	this.x = x;
	this.y = y;
};
$hxClasses['com.inq.utils.Point'] = com.inq.utils.Point;
/** @private @type {Array} */
com.inq.utils.Point.__name__ = ["com","inq","utils","Point"];

/**
 * copy - Makes a copy of this Point.
 * @return {com.inq.utils.Point} A copy of this Point.
 */
com.inq.utils.Point.prototype.copy = function() {
	return new com.inq.utils.Point(this.x, this.y);
};


/**
 * toString
 * Format this object as a string, for debugging purposes.
 *
 * $type TFun([],TInst(String,[]))
 * public function toString():String
 * @public
 * @this com.inq.utils.Point
 * @return {string}
 */
com.inq.utils.Point.prototype.toString = function() {
	return "Point[x: " + this.x + ", y: " + this.y + "]";
};


/**
 * diff
 * Returns a Point that can be used as a vector to pass x and y
 * values to move().
 * 
 * if:   d == a.diff(b)
 * then: a.move(d) == b
 *
 * $type TFun([{ name => p, t => TInst(com.inq.utils.Point,[]), opt => false }],TInst(com.inq.utils.Point,[]))
 * public function diff(p:Point):Point
 * @public
 * @this com.inq.utils.Point
 * @param {com.inq.utils.Point}  p 
 * @return {com.inq.utils.Point}
 */
com.inq.utils.Point.prototype.diff = function (p) {
	/** @type {number} */
	var x = p.x - this.x;
	/** @type {number} */
	var y = p.y - this.y;
	return new com.inq.utils.Point(x,y);
};


/**
 * Is this point equivalent to the given point?
 *
 * @param {com.inq.utils.Point} p The point to compare to.
 * @return {boolean} Are the two points equivalent?
 */
com.inq.utils.Point.prototype.equals = function(p) {
    return p.x == this.x && p.y == this.y;
};


/**
 * moveTo
 * move - Adjusts the position of this Point.
 *
 * $type TFun([{ name => x, t => TInst(Int,[]), opt => false },{ name => y, t => TInst(Int,[]), opt => false }],TInst(com.inq.utils.Point,[]))
 * public function moveTo(x:Int, y:Int):Point
 * @public
 * @this com.inq.utils.Point
 * @param {number}  x 
 * @param {number}  y 
 * @return {com.inq.utils.Point} - this Point.
 */
com.inq.utils.Point.prototype.moveTo = function(x,y) {
	this.x += x;
	this.y += y;
	return this;
};


/**
 * move - Adjusts the position of this Point.
 *
 * $type TFun([{ name => dx, t => TInst(Int,[]), opt => false },{ name => dy, t => TInst(Int,[]), opt => false }],TInst(com.inq.utils.Point,[]))
 * public function move(dx:Int, dy:Int):Point
 * @public
 * @this com.inq.utils.Point
 * @param {number}  dx 
 * @param {number}  dy 
 * @return {com.inq.utils.Point} - this Point.
 */
com.inq.utils.Point.prototype.move = function(dx,dy) {
	this.x += dx;
	this.y += dy;
	return this;
};

/**
 * moveInto - Moves this point so that it lies within the given Area.
 * @param {com.inq.utils.Area} area
 * @return {com.inq.utils.Point} - this Point
 */
com.inq.utils.Point.prototype.moveInto = function(area) {
	this.x = this.forceRange(this.x, area.x, (area.x + area.w));
	this.y = this.forceRange(this.y, area.y, (area.y + area.h));
};

/**
 * forceRange
 *
 * $type TFun([{ name => x, t => TInst(Int,[]), opt => false },{ name => min, t => TInst(Int,[]), opt => false },{ name => max, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * private function forceRange(x:Int, min:Int, max:Int):Int
 * @private
 * @this com.inq.ui.TextArea
 * @param {number}  x
 * @param {number}  min
 * @param {number}  max
 * @return {number}
 */
com.inq.utils.Point.prototype.forceRange = function(x,min,max) {
	/** @type {number} */
	var r = x;
	if (r > max) {
		r = max;
	}
	if (r < min) {
		r = min;
	}
	return r;
};

/** @type {number} */
com.inq.utils.Point.prototype.y = null;
/** @type {number} */
com.inq.utils.Point.prototype.x = null;
/** @type {com.inq.utils.Point} */
com.inq.utils.Point.prototype.__class__ = com.inq.utils.Point;
